import { render, staticRenderFns } from "./GSubTitleBar.vue?vue&type=template&id=2f5fb4b4&scoped=true&"
import script from "./GSubTitleBar.vue?vue&type=script&lang=ts&"
export * from "./GSubTitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./GSubTitleBar.vue?vue&type=style&index=0&id=2f5fb4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5fb4b4",
  null
  
)

export default component.exports